module.exports = __webpack_public_path__ + "static/media/logo.5399fd72.png";